import { types } from 'mobx-state-tree';
import { firebase } from '../utils/Firebase';
import LoginApi from '../api/LoginApi';

export const ApiStore = types
  .model('ApiStore', {
    isFirebaseLoaded: false,
    isLoggedIn: false,
  })
  .volatile(() => ({}))
  .actions(self => ({
    afterCreate() {
      firebase.auth().onAuthStateChanged(user => self.setLogin(user));
    },
    loginApi(email, password) {
      return LoginApi(email, password).then(token =>
        firebase.auth().signInWithCustomToken(token));
    },
    setLogin(user) {
      if (!self.isFirebaseLoaded) self.isFirebaseLoaded = true;
      self.isLoggedIn = !!user;
    },
    signOut() {
      return firebase.auth().signOut();
    },
  }));



// WEBPACK FOOTER //
// ./src/stores/ApiStore.js